import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ErrorService } from '../../error/error.service';
import { LoadingService } from '../../loading/loading.service';
import { LoggingService } from '../../logging/logic/logging.service';
import { SyncService } from '../../sync/sync.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { IMSAction } from 'src/app/_model/menu';
import { LBSUtils } from 'src/app/_util/lbs-utils';
import { PeripheralsService } from '../../peripherals/logic/peripherals.service';
import { LBSErrorHandlerService } from '../../error-handler/error-handler.service';

export const RequestBTPermissionAction: IMSAction = {
  type: 'action',
  target: 'request_bt_permission',
}

@Injectable({
  providedIn: 'root'
})
export class RequestBluetoothPermissionActionHandler implements ActionHandler {
  // Public Member
  public readonly name: ActionHandlerType = 'request_bt_permission';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private translate: TranslateService,
    private peripheralsService: PeripheralsService,
    private errorService: ErrorService,
    private errorHandlerService: LBSErrorHandlerService,
  ) { }

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    try {
        await this.peripheralsService.requestBluetoothPermissions()
    } catch(e) {
        this.errorService.showErrorHandlerResult(await this.errorHandlerService.handleError(e))
    }
  }

  // Private Functions
}
